import React, { useState, useRef, useEffect } from "react";
import styles from './neetmocktest.module.css';
import mockTestIcon1 from '../../assets/benchmarking_1.svg';
import mockTestIcon2 from '../../assets/exam_2.svg';
import mockTestIcon3 from '../../assets/analytics_3.svg';
import swipecard from '../../assets/swipe_background_imagew.png'

const generateNewCard = (id) => ({
    id: Math.random(), // Unique ID
    color: ["purple", "blue", "indigo"][Math.floor(Math.random() * 3)],
    image: `https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/neet-mock/neet_${id}.png`,
});
var imageid = 3;
const initialCards = [generateNewCard(1), generateNewCard(2), generateNewCard(3)];
const NeetMockTestcategory = () => {
    const [cards, setCards] = useState(initialCards);
    const [animating, setAnimating] = useState(false);
    const cardRefs = useRef([]);

    useEffect(() => {
        updateCardStyles();
    }, [cards]);

    const handleDragStart = (e, index) => {
        if (animating) return;
        const startX = e.type === "mousedown" ? e.pageX : e.touches[0].pageX;
        let pullDeltaX = 0;

        const handleDragMove = (e) => {
            const x = e.type === "mousemove" ? e.pageX : e.touches[0].pageX;
            pullDeltaX = x - startX;
            const rotation = pullDeltaX / 10;
            if (cardRefs.current[index]) {
                cardRefs.current[index].style.transform = `translateX(${pullDeltaX}px) rotate(${rotation}deg)`;
            }
        };

        const handleDragEnd = () => {
            document.removeEventListener("mousemove", handleDragMove);
            document.removeEventListener("mouseup", handleDragEnd);
            document.removeEventListener("touchmove", handleDragMove);
            document.removeEventListener("touchend", handleDragEnd);
            imageid = imageid+1;
            if (Math.abs(pullDeltaX) > 80) {
                setAnimating(true);
                cardRefs.current[index].classList.add(pullDeltaX > 0 ? "to-right" : "to-left");

                setTimeout(() => {
                    setCards((prev) => {
                        if (imageid >=5){
                            imageid =1;
                        }
                        const newCard = generateNewCard(imageid);
                        return [...prev.slice(1), newCard]; // Always keep only 3 cards
                    });
                    setAnimating(false);
                }, 300);
            } else {
                if (cardRefs.current[index]) {
                    cardRefs.current[index].style.transform = "";
                }
            }
        };

        document.addEventListener("mousemove", handleDragMove);
        document.addEventListener("mouseup", handleDragEnd);
        document.addEventListener("touchmove", handleDragMove);
        document.addEventListener("touchend", handleDragEnd);
    };

    const updateCardStyles = () => {
        const cardElements = cardRefs.current;
        cardElements.forEach((card, index) => {
            if (card) {
                const zIndex = cards.length - index;
                const scale = 1 - index * 0.10;
                const translateY = index * 10;
                card.style.zIndex = zIndex;
                card.style.transform = `translateY(${translateY}px) scale(${scale})`;
            }
        });
    };

    return (
        <div>
            {/* ---------MOCK NEET MOCK test desktop*/}
            <div className={`${styles.d_block}`}>
                <div className={`${styles.mocktest_bg}`}>
                    <div className='container'>
                        <div className={`${styles.mocktest_heading}`}>
                            <h2>Why should you take a Mock Test?</h2>
                        </div>
                        <div className={`${styles.mocktest_wrapper}`}>
                            {/* box1 */}
                            <div className={`${styles.mocktest_box1}`}>
                                <div className={`${styles.mocktest_icon1}`}>
                                    <img src={mockTestIcon1} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>NEET Performance Benchmarking</h2>
                                    <p>Benchmark your performance with other aspirants to assess your NEET readiness</p>
                                </div>
                            </div>
                            {/* box1 */}
                            {/* box2 */}
                            <div className={`${styles.mocktest_box1}`}>
                                <div className={`${styles.mocktest_icon2}`}>
                                    <img src={mockTestIcon2} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>NEET Exam Simulation</h2>
                                    <p>Get a real NEET Exam simulated experience to boost your confidence</p>
                                </div>
                            </div>
                            {/* box2 */}
                            {/* box3 */}
                            <div className={`${styles.mocktest_box1}`}>
                                <div className={`${styles.mocktest_icon3}`}>
                                    <img src={mockTestIcon3} alt="mocktest" />
                                </div>
                                <div className={`${styles.mocktest_content}`}>
                                    <h2>NEET Subject-Wise Analytics</h2>
                                    <p>Get subject-wise analytics to help improve weak areas.</p>
                                </div>
                            </div>
                            {/* box3 */}
                        </div>
                    </div>
                </div>
            </div>
            {/* ---------MOCK NEET MOCK test desktop*/}
            <div className={`${styles.m_block}`}>
                <div className={`${styles.mocktest_bg}`}>
                    <div className='container p-0'>
                        <div className={`${styles.mocktest_heading} pe-4 ps-4`}>
                            <h2>Why should you take a Mock Test?</h2>
                        </div>
                        <div className={`${styles.swipe_img}`}>
                            <img src={swipecard}/>
                        <div className={`${styles.slidelr}`}>
                        <div className={`${styles.demo}`}>
                            <div className={`${styles.demo__content}`}>
                                <div className={`${styles.demo__card_cont}`}>
                                    {cards.map((card, index) => (
                                        <div
                                            key={card.id}
                                            ref={(el) => (cardRefs.current[index] = el)}
                                            className={`${styles.demo__card} ${card.color}`}
                                            onMouseDown={(e) => handleDragStart(e, index)}
                                            onTouchStart={(e) => handleDragStart(e, index)}
                                        >
                                            <div className={`${styles.demo__card__top} ${styles[card.color]}`}>
                                                <div
                                                    className={`${styles.demo__card__img}`}
                                                    style={{ backgroundImage: `url(${card.image})` }}
                                                ></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NeetMockTestcategory;